<script setup>
const props = defineProps({
  h2: { type: String },
  body: { type: String },
  cta: {
    type: Object,

    validate: (value) => {
      return typeof value.label === "string" && typeof value.path === "string";
    },
  },
  image: {
    type: Object,
    validate: (value) => {
      return typeof value.src === "string" && typeof value.alt === "string";
    },
  },
});
</script>

<template>
  <section
    class="font-iq-paragraph leading-iq-paragraph tracking-iq-paragraph text-iq-paragraph-color grid items-center gap-10 md:grid-cols-2"
  >
    <FlexuilibMagicImg
      :src="image.src"
      :alt="image.alt"
      fit="cover"
      class="w-full object-cover object-top aspect-[16/9] md:rounded-iq-roundness"
    />

    <!-- Copy -->
    <div class="px-2 md:px-0">
      <h2
        class="text-4xl font-bold md:text-5xl font-iq-header leading-iq-header tracking-iq-header text-iq-header-color"
      >
        {{ h2 }}
      </h2>

      <slot name="body">
        <p class="mt-6 text-lg">
          {{ body }}
        </p>
      </slot>

      <div class="mt-8">
        <FlexuilibCta
          :label="cta.label"
          :path="cta.path"
          :type="cta.type"
          :icon="cta.icon"
        />
      </div>
    </div>
  </section>
</template>
